import React from 'react';
import ContactHero from '../components/ContactHero/ContactHero';
import ContactForm from '../components/ContactForm/ContactForm';
import ContactInfo from '../components/ContactInfo/ContactInfo';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <div className="contact-us">
      <ContactHero />
      
      {/* Contact Form & Info Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs; 